import { useParams } from 'react-router-dom';

import { useChargePointsGroupFetchingContext } from 'entities/charge-point/charge-points-group-layout';

import { ConnectedReservesTable } from '../../../widgets/session/reserve-sessions-table/ui/connected-table';

export function ChargePointsGroupReservesPage() {
  const { chargePointName, groupId } = useParams() as {
    chargePointName: string;
    groupId: string;
  };

  const { handleSetFetchingTab } = useChargePointsGroupFetchingContext();

  return (
    <ConnectedReservesTable
      handleSetFetchingTab={handleSetFetchingTab}
      groupId={groupId}
    />
  );
}
